import styled from 'styled-components';

import {
  PageHeader,
  Flexbox,
  Button,
  TextInput,
  BinderLogoPicker,
  ColorPicker
} from '@ibinder/common-frontend';

import CreateBinderModalFooter from 'Shared/modal/createBinderModals/creatBinderModalFooter';

// Styles
export const Wrapper = styled(Flexbox)`
  width: 100%;
  flex-direction: column;
  min-height: 100%;
`;

export const PageHeaderHeight = styled(PageHeader)`
  min-height: 5rem;
  height: auto;
  margin-bottom: 0;
  width: 100%;
`;

export const AlignToTop = styled(Flexbox)``;

export const Header = styled(Flexbox)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const BinderInformationContent = styled(Flexbox)`
  padding: 1rem;
  justify-content: space-between;
  margin-right: 2.875rem;
`;

export const EditBinderWrapper = styled(Flexbox)`
  padding-top: 1rem;
  flex-direction: column;
  height: fit-content;
`;
export const EditBinderInformationContent = styled(Flexbox)`
  padding: 0 1rem;
  justify-content: space-between;
`;
export const HalfCol = styled.div`
  width: Calc(50% - 0.5rem);
`;

export const Logo = styled.img`
  height: 2.375rem;
`;

export const Data = styled(Flexbox)`
  flex-direction: column;
`;

export const BinderVerboseDescription = styled(Flexbox)`
  border: 0.0625rem dashed ${({ theme }) => theme.colors.discrete30};
  border-radius: 0.25rem;
  height: 18.5rem;
  margin: 0 1rem;
  margin-top: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  > svg {
    height: 6rem;
    width: 6rem;
    path {
      fill: ${({ theme }) => theme.colors.discrete30};
    }
  }
  > span {
    margin-bottom: 2rem;
  }
`;

export const Head = styled.div`
  color: ${({ theme }) => theme.colors.discrete70};
  font-weight: ${(props) => props.theme.fontStyles.extraSmallFont.fontWeight};
  font-size: ${(props) => props.theme.fontStyles.extraSmallFont.fontSize}px;
`;

export const Bread = styled.div`
  color: ${({ theme }) => theme.colors.discrete};
  font-weight: ${(props) => props.theme.fontStyles.smallFont.fontWeight};
  font-size: ${(props) => props.theme.fontStyles.smallFont.fontSize}px;
`;

export const StyledButton = styled(Button)`
  width: auto;
  height: 3rem;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;

  > span {
    padding-right: 1rem;
  }
  > svg {
    height: 2.75rem;
    width: 2.75rem;
  }
  &:hover,
  &:focus {
    background: ${(props) => props.theme.colors.primary10};
    color: ${(props) =>
      props.selected ? props.theme.dropdown.primaryTextColor : ''};
    outline: 0;
  }
  &:active {
    background: ${(props) => props.theme.colors.primary20};
  }
  &:first-child {
    border-top-right-radius: 0.3125rem;
    border-top-left-radius: 0.3125rem;
  }
  &:last-child {
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
  }
`;
export const ActionWrapper = styled(Flexbox)`
  flex-direction: column;
`;

export const StyledTextInput = styled(TextInput)`
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;

  width: 100%;
`;
export const StyledBinderLogoPicker = styled(BinderLogoPicker)`
  margin-bottom: 0.75rem;
  width: 100%;
  > div {
    display: flex;
    justify-content: space-between;
  }
  > div > div {
    max-width: Calc(50% - 0.5rem);
  }
`;
export const StyledColorPicker = styled(ColorPicker)`
  margin-bottom: 0.75rem;
`;

export const StyledCreateBinderModalFooter = styled(CreateBinderModalFooter)`
  margin-top: auto;
  position: sticky;
  bottom: 0;
  box-shadow: 0 0 0.375rem ${({ theme }) => theme.colors.discreteOpacity50};
`;
